import {useTranslation} from 'react-i18next';
import MainScreenButton from '../../../../../components/forms/mainScreenButton';
import React from 'react';
import {useDispatch} from 'react-redux';
import {openPatientForm} from '../../../../../store/reducers/patientContext';
import moment from 'moment';

const SeniorReviewButton = ({patient, disableSave}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const value = patient?.seniorReview || {who: null, when: moment(), text: ''};

    return (
        <MainScreenButton
            value={value}
            filled={value && value.who && value.when}
            disabled={disableSave}
            label={t('Senior Review')}
            onOpen={() => dispatch(openPatientForm('seniorReview'))}
        />
    );
};

export default SeniorReviewButton;